import { CommonTabbarContext } from "@/App";
import { TAB_TYPE } from "@/enums/tab-type";
import { Button, Input, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { CommonTabbarState, TabRoute } from "tncet-common";
import "./index.less"
import { useParams } from "react-router";
import { sendMsgToAiServer } from "@/api/device/sensor";
import { VideoMonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import { getVideoMonitorObjectByProjectId } from "@/api/monitor-object/calibration";
import { updateVideoMonitorParam } from "@/api/monitor-object/calibration"; // 确保已正确引入

export default function CalibrationCameraPanel() {

    const { projectId } = useParams();

    const [monitorParamList, setMonitorParamList] = useState<VideoMonitorParameter[]>([])

    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);


    useEffect(() => {
        let addTab: TabRoute = {
            title: "标定",
            url: `${TAB_TYPE.CALIBRATION}`,
            closable: true
        }
        commonTabbarContext.pushRoute(addTab)
    }, [])

    useEffect(() => {
        generateData()
    }, [projectId])

    const generateData = () => {
        getVideoMonitorObjectByProjectId(+projectId).then(res => {
            let mList: VideoMonitorParameter[] = res.data || []
            mList = mList.filter(item => item.globalMonitorParameterId == 4);  //视频的
            setMonitorParamList(mList)
        })
    }

    const handleSave = (record: VideoMonitorParameter) => {
        updateVideoMonitorParam(record.id, record)
            .then(() => {
                console.log("保存成功");
                // 更新前端状态
                setMonitorParamList((prevList) =>
                    prevList.map((item) =>
                        item.id === record.id ? { ...item, ...record } : item
                    )
                );
            })
            .catch((err) => {
                console.error("保存失败", err);
            });
    };

    const sendMessageToServer = (record: VideoMonitorParameter) => {
        const sendData = {
            local_ip: record.localIp,
            user: record.user,
            password: record.password,
            param_id: record.superMonitorParameterId,
            sensor_param_id: record.sensorParameterId,
        }

        sendData["type"] = "calibration";
        sendMsgToAiServer(+projectId, sendData)
    }

    const columns = [
        {
            title: "监测参数",
            dataIndex: "encoding",
            key: "encoding",
            render: (_: string, record: VideoMonitorParameter) => (
                <span>{record.monitorObjectId} - {record.location}</span>
            ),
        },
        {
            title: "IP地址",
            dataIndex: "localIp",
            key: "localIp",
            width: 150, // 设置较小的宽度
            render: (_, record: VideoMonitorParameter) => (
                <Input
                    placeholder="请输入IP地址"
                    defaultValue={record.localIp}
                    onBlur={(e) => {
                        record.localIp = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                    onPressEnter={(e) => {
                        record.localIp = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                />
            ),
        },
        {
            title: "用户名",
            dataIndex: "user",
            key: "user",
            width: 120, // 设置较小的宽度
            render: (_, record: VideoMonitorParameter) => (
                <Input
                    placeholder="请输入用户名"
                    defaultValue={record.user}
                    onBlur={(e) => {
                        record.user = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                    onPressEnter={(e) => {
                        record.user = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                />
            ),
        },
        {
            title: "密码",
            dataIndex: "password",
            key: "password",
            width: 120, // 设置较小的宽度
            render: (_, record: VideoMonitorParameter) => (
                <Input
                    type="password"
                    placeholder="请输入密码"
                    defaultValue={record.password}
                    onBlur={(e) => {
                        record.password = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                    onPressEnter={(e) => {
                        record.password = (e.target as HTMLInputElement).value;
                        handleSave(record);
                    }}
                />
            ),
        },
        {
            title: "经度",
            dataIndex: "longitude",
            key: "longitude",
            render: (longitude: number) => <span>{longitude ?? "暂无"}</span>,
        },
        {
            title: "纬度",
            dataIndex: "latitude",
            key: "latitude",
            render: (latitude: number) => <span>{latitude ?? "暂无"}</span>,
        },
        {
            title: "缩放系数",
            dataIndex: "focalZoom",
            key: "focalZoom",
            render: (focalZoom: number) => <span>{focalZoom ?? "暂无"}</span>,
        },
        {
            title: "操作",
            key: "action",
            render: (_, record: VideoMonitorParameter) => (
                <>
                    <Button onClick={() => sendMessageToServer(record)}>ip同步</Button>
                    <Button onClick={() => sendMessageToServer(record)}>ip测试</Button>
                    <Button onClick={() => sendMessageToServer(record)}>经纬记录</Button>
                </>
            ),
        },
    ];

    return (
        <div className="calibration-camera-panel">
            <Table
                dataSource={monitorParamList}
                columns={columns}
                rowKey="sensorParameterId"
                pagination={false}
                scroll={{ x: "max-content", y: 400 }} // 启用水平和垂直滚动
            />
        </div>
    );
}